var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0097ff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.26 10.5c.318-.038.64.007.936.131a.7.7 0 0 1 .298.298c.124.295.17.618.13.936v4.27c.04.318-.006.64-.13.936a.7.7 0 0 1-.298.298c-.295.124-.618.17-.936.131H5.74a1.846 1.846 0 0 1-.936-.131.7.7 0 0 1-.298-.298 1.846 1.846 0 0 1-.131-.936v-4.27c-.038-.318.007-.64.131-.936a.7.7 0 0 1 .298-.298c.295-.124.618-.17.936-.131a.875.875 0 0 0 0-1.75 3.36 3.36 0 0 0-1.75.341 2.371 2.371 0 0 0-1.024 1.015 3.36 3.36 0 0 0-.341 1.75v4.27a3.36 3.36 0 0 0 .341 1.75c.225.435.58.79 1.015 1.015a3.36 3.36 0 0 0 1.75.342h9.529a3.36 3.36 0 0 0 1.75-.342c.435-.225.79-.58 1.015-1.015a3.36 3.36 0 0 0 .341-1.75v-4.261a3.36 3.36 0 0 0-.341-1.75A2.372 2.372 0 0 0 17.01 9.1a3.36 3.36 0 0 0-1.75-.341.875.875 0 1 0 0 1.75V10.5ZM9.625 4.742V14a.875.875 0 0 0 1.75 0V4.734l2.004 2.012a.875.875 0 1 0 1.242-1.234l-3.5-3.5a.875.875 0 0 0-1.33.088L6.38 5.512A.879.879 0 1 0 7.62 6.755l2.004-2.013Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.bdff29feb473094c7ac2842319c26590.svg";
export { ForwardRef as ReactComponent };